import React, { useState } from 'react';

import Loading from '../../components/base/Loading';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import DocumentChunking from './DocumentChunking/DocumentChunking';
import { isAdmin } from '../../constants';
import { ExtractTargets } from './ExtractTargets/ExtractTargets';
import { MenuProps } from 'antd';
import { TextWithDropdown } from '@relyant/ui';

const AdminView = () => {
  const { user } = useAuth0();
  const [currentView, setCurrentView] = useState<string>('targets-extraction');

  if (user && !isAdmin(user)) {
    return null;
  }

  const keyView = {
    'document-chunking': {
      title: 'Document chunking',
      view: <DocumentChunking />,
    },
    'targets-extraction': {
      title: 'Target extraction',
      view: <ExtractTargets />,
    },
  };

  const dropdDownItems: MenuProps['items'] = [
    {
      key: '1',
      label: 'Target extraction',
      onClick: () => {
        setCurrentView('targets-extraction');
      },
      style: { fontSize: 16 },
    },
    {
      key: '2',
      label: 'Document chunking',
      onClick: () => {
        setCurrentView('document-chunking');
      },
      style: { fontSize: 16 },
    },
  ];

  return (
    <div style={{ padding: 32 }}>
      <TextWithDropdown title={keyView[currentView].title} dropdDownItems={dropdDownItems} />
      <div style={{ paddingTop: 32 }}>{keyView[currentView].view}</div>
    </div>
  );
};

export default withAuthenticationRequired(AdminView, {
  onRedirecting: () => <Loading />,
});
